import 'core-js/modules/es.object.assign.js';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { useIsMobile, Stack, Text } from '@hub-la/design-system';
import { useFeatureFlag, FLAGS } from '@hub-la/fe-core-feature-flag';
import { useEffect } from 'react';
import { GetReleaseTime } from '../../../usecases/get-release-time.js';
import { AdminActions } from '../../components/admin-actions.js';
import { BackButton } from '../../components/back-button.js';
import { Error } from '../../components/error.js';
import { LoadingState } from '../../components/loading-state.js';
import { Overlay } from '../../components/overlay/overlay.js';
import { Paywall } from '../../components/paywall/paywall.js';
import { PostContent } from '../../components/post-content/post-content.js';
import UserNavigation from '../../components/user-navigation.js';
import useCurrentUser from '../../hooks/use-current-user.js';
import { useGetPost } from '../../hooks/use-get-post.js';
import { useGetSections } from '../../hooks/use-get-sections.js';

const PostDetail = props => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _j;
  const currentUser = useCurrentUser();
  const {
    postId
  } = props;
  const {
    isFetching,
    data: post,
    refetch: refetchPost,
    isError,
    error
  } = useGetPost({
    postId
  });
  const {
    isFlagEnabled
  } = useFeatureFlag();
  const isNewListSectionsEnabled = isFlagEnabled(FLAGS.LIST_SECTIONS.IS_NEW_LIST_SECTIONS_ENABLED, {
    id: (_c = (_b = (_a = post === null || post === void 0 ? void 0 : post.product) === null || _a === void 0 ? void 0 : _a.owner) === null || _b === void 0 ? void 0 : _b.id) !== null && _c !== void 0 ? _c : ''
  });
  const {
    refetch: refetchSections
  } = useGetSections({
    productId: (_e = (_d = post === null || post === void 0 ? void 0 : post.product) === null || _d === void 0 ? void 0 : _d.id) !== null && _e !== void 0 ? _e : ''
  }, isNewListSectionsEnabled);
  const isMobile = useIsMobile();
  const isAdmin = (post === null || post === void 0 ? void 0 : post.roleType) === 'creator';
  const canAccess = (post === null || post === void 0 ? void 0 : post.roleType) !== 'not-member';
  const onPublish = () => {
    refetchPost();
    refetchSections();
  };
  /**
   * Refetch post and sections because on sign-in with cookie the token updated async.
   */
  useEffect(() => {
    if (canAccess || !(currentUser === null || currentUser === void 0 ? void 0 : currentUser.id)) return;
    refetchPost();
    refetchSections();
  }, [canAccess, currentUser === null || currentUser === void 0 ? void 0 : currentUser.id]);
  if (isError) {
    return jsx(Error, {
      errorKey: error === null || error === void 0 ? void 0 : error.message
    });
  }
  return jsxs(Stack, Object.assign({
    flex: 1,
    position: "relative",
    minHeight: "100vh"
  }, {
    children: [!isMobile && jsx(Overlay, {
      image: (_f = post === null || post === void 0 ? void 0 : post.product) === null || _f === void 0 ? void 0 : _f.cover
    }), post ? jsxs(Fragment, {
      children: [!canAccess && jsx(Paywall, {
        productName: post === null || post === void 0 ? void 0 : post.product.name,
        groupId: post === null || post === void 0 ? void 0 : post.currentOfferId
      }), jsxs(Stack, Object.assign({
        paddingX: [4, 10],
        height: "110px",
        alignItems: "center",
        direction: "row"
      }, {
        children: [jsxs(Stack, Object.assign({
          flex: 1,
          gap: [1, 4],
          direction: "row",
          alignItems: "center"
        }, {
          children: [jsx(BackButton, {
            groupId: post === null || post === void 0 ? void 0 : post.currentOfferId
          }), jsx(Text, Object.assign({
            color: "onBackground",
            variant: "h4",
            style: {
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              maxWidth: '55vw'
            }
          }, {
            children: (_g = post === null || post === void 0 ? void 0 : post.product) === null || _g === void 0 ? void 0 : _g.name
          }))]
        })), isAdmin && !isMobile && jsx(AdminActions, {
          post: post,
          productId: (_h = post === null || post === void 0 ? void 0 : post.product) === null || _h === void 0 ? void 0 : _h.id,
          sectionId: post === null || post === void 0 ? void 0 : post.sectionId,
          onPublish: onPublish
        }), jsx(UserNavigation, {})]
      })), isAdmin && isMobile && jsx(AdminActions, {
        post: post,
        productId: (_j = post === null || post === void 0 ? void 0 : post.product) === null || _j === void 0 ? void 0 : _j.id,
        sectionId: post === null || post === void 0 ? void 0 : post.sectionId,
        onPublish: onPublish
      }), jsx(PostContent, {
        post: post,
        loading: isFetching,
        timeToRelease: (post === null || post === void 0 ? void 0 : post.releaseAt) ? new GetReleaseTime().execute(new Date(post === null || post === void 0 ? void 0 : post.releaseAt)) : undefined,
        canAccess: canAccess,
        isBeta: isNewListSectionsEnabled
      })]
    }) : jsx(LoadingState, {})]
  }));
};

export { PostDetail };
